import { createReducer } from 'typesafe-actions';
import { createRoutineReducers, getInitialState } from '../common/utils/routine-reducer.js';
import { CLEAR_VERSION_LIST, getVersionListRoutine } from './actions.js';
import type { LIST_NAME } from './constants.js';
import type { Version } from './types.js';

export const initialVersionListData: VersionListData = {
  items: [],
  total: 0,
  from: 0,
  size: 0
};

export type ItemStatusMap = Record<number, 'loaded' | 'loading'>;

export type VersionListData = {
  items: Version[];
  total: number;
  from: number;
  size: number;
};

export type VersionListState = {
  loading: boolean;
  loaded: boolean;
  saving: boolean;
  error: string;
  data: VersionListData;
};

export type VersionListSlice = {
  [LIST_NAME]: VersionListState;
};

export const initialState: VersionListState = getInitialState(initialVersionListData, 'loading', 'loaded', {
  itemStatusMap: {}
});

export default createReducer<VersionListState>(initialState, {
  ...createRoutineReducers(getVersionListRoutine),
  [CLEAR_VERSION_LIST]: (state: VersionListState): VersionListState => ({
    ...state,
    data: initialVersionListData
  })
});
